import { isAxiosError } from "axios";

const LEGACY_VALIDATION_STATUS = 366;

type TLegacyValidationBody = {
  Result?: unknown;
  Error?: unknown;
};

const flattenMessages = (result: unknown): string[] => {
  if (typeof result === "string") return result ? [result] : [];

  if (Array.isArray(result)) {
    return result.flatMap((item) => flattenMessages(item));
  }

  if (result && typeof result === "object") {
    return Object.values(result).flatMap((value) => flattenMessages(value));
  }

  return [];
};

export const mapLegacyValidationError = (
  error: unknown
): { Ok: false; Error: string } | null => {
  if (
    !isAxiosError(error) ||
    error.response?.status !== LEGACY_VALIDATION_STATUS
  ) {
    return null;
  }

  const body = error.response.data as TLegacyValidationBody | undefined;
  const messages = flattenMessages(body?.Result);
  const fallback =
    typeof body?.Error === "string" && body.Error !== "ValidationError"
      ? body.Error
      : "";

  return {
    Ok: false,
    Error:
      messages.join(" ") || fallback || "Não foi possível concluir a operação."
  };
};
